// ===== 全局 console.log 控制（必须在所有其他 import 之前） =====
import '@/common/src/utils/console'

// core
import App from '@/App.vue'
import VueI18n from '@/locales/index'
import router from '@/router'
import '@/router/permission'
import store from '@/store'
import indexDB from '@/utils/indexdb'
import { createApp } from 'vue'
// load
import { loadSvg } from '@/assets/icons'
// css
import '@/styles/index.scss'
import 'element-plus/theme-chalk/dark/css-vars.css'
import 'uno.css'
// 全局指令
import dateFormat from '@/common/src/directives/dateFormat'

// await
indexDB.init() // 在入口函数初始化
const app = createApp(App)
// 全局指令
app.directive('dateFormat', dateFormat)

/** 加载全局 SVG */
loadSvg(app)

app.use(store).use(VueI18n).use(router)
router
  .isReady()
  .then(() => {
    app.mount('#app')
  })
  .catch((err) => {
    console.error('[router.isReady] 初始化導航失敗，頁面將保持空白', err)
  })
